import React, { useState, useEffect } from 'react';
import aboutImg1 from "../../../assets/images/aboutImg1.svg"
import aboutImg2 from "../../../assets/images/aboutImg2.svg"
import aboutImg3 from "../../../assets/images/aboutImg3.svg"


function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercentage = (scrollPosition / documentHeight) * 100;
      if (scrollPercentage >= 2) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='bg-bg-white py-[100px] h-full'>
      <div className='container mx-auto px-4 md:px-0'>
        <h1 className='font-semibold text-[28px] leading-[36px] md:font-bold md:text-5xl md:leading-[56px] text-center max-w-[839px] w-full mx-auto font-sfpro'>We’re just humans changing how brand stories and strategies are brought to life </h1>
        <div className="my-[29px] md:my-[120px] relative flex justify-center ">
          <img src={aboutImg2} alt="About Hero" className={`w-full md:block hidden max-w-[131px] md:max-w-[452px] pointer-events-none z-30 ${isScrolled ? `box-1` : `box-close1`}`}  /> 
          <img src={aboutImg1} alt="About Hero" className="w-full max-w-[131px] md:max-w-[452px] pointer-events-none z-40" /> 
          <img src={aboutImg3} alt="About Hero" className={`w-full md:block hidden max-w-[131px] md:max-w-[452px] pointer-events-none z-30 ${isScrolled ? `box-2` : `box-close2`}`} /> 
        </div>
      </div>
    </div>
  );
}

export default Hero;
